import React, { useState } from 'react';
import { Radio, message } from 'antd';
import DefaultForm from 'components/form/DefaultForm';
import DefaultModal from 'components/modal/DefaultModal';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { handleMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';
import { modelAPI } from 'apis/resource/modelAPI';
import InputStyled from 'components/InputStyled';
import InputWithCounter from 'components/input/InputWithCounter';
import { IModel } from 'utils/types/storyTypes';
/**
 * * 리소스 - 모델 세부정보 편집
 */

interface IProps {
  visible: boolean;
  setVisible: (e: any) => void;

  selectedData: IModel | null;
  setSelectedData: React.Dispatch<IModel | null>;

  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
}

const ModelUpdateModal = ({
  visible,
  setVisible,
  selectedData,
  setSelectedData,
  setRefresh,
  refresh,
}: IProps) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setVisible(false);
  };
  const [loading, setLoading] = useState<boolean>(false);
  /// 서버 전송
  const handleSubmit = async () => {
    if (selectedData) {
      const postData = {
        update: selectedData,
      };
      try {
        setLoading(true);
        await modelAPI.modelUpdate(
          selectedData.project_id,
          selectedData.model_id,
          postData,
        );
        setRefresh(!refresh);
        setVisible(false);
        setLoading(false);
        handleMessage(message, 'success', 'Success');
      } catch (err) {
        console.log('update error', err);
        setLoading(false);
        handleMessage(message, 'error', 'Error');
      }
    }
  };

  const handleInputChange = (e, type: string) => {
    if (selectedData) {
      const cloneData = JSON.parse(JSON.stringify(selectedData));
      cloneData[type] =
        type === 'model_name' || type === 'direction'
          ? e.target.value
          : Number(e.target.value);
      setSelectedData(cloneData);
    }
  };

  return (
    <DefaultModal
      title={t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.characterContent.updateModelModal.title',
      )}
      visible={visible}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('updateStory.form.buttonSubmit')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
          />
        </ButtonWrapper>
      }
    >
      <DefaultForm>
        <FormWrapper>
          <HeaderWrapper>
            <p>ID: {selectedData?.model_id}</p>
          </HeaderWrapper>
          <div>
            <p className='title'>
              {t(
                'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.characterContent.updateModelModal.form.characterName',
              )}
            </p>
            <InputWithCounter
              value={selectedData?.model_name}
              onChange={(e) => {
                handleInputChange(e, 'model_name');
              }}
              maxLength={30}
              disabled={true}
            />
          </div>
          <div>
            <p className='title'>
              인게임 가로 위치 조정값 (0이 화면 중앙 기준, 음수는 왼쪽, 양수는
              오른쪽 이동)
            </p>
            <InputStyled
              value={selectedData?.offset_x}
              onFocus={(e) => e.target.select()}
              onChange={(e) => {
                handleInputChange(e, 'offset_x');
              }}
              maxLength={30}
              type='number'
            />
          </div>
          <div>
            <p className='title'>
              인게임 세로 위치 조정값 (0이 화면 중앙 기준, 음수는 아래, 양수는
              위로 이동)
            </p>
            <InputStyled
              value={selectedData?.offset_y}
              onFocus={(e) => e.target.select()}
              onChange={(e) => {
                handleInputChange(e, 'offset_y');
              }}
              maxLength={30}
              type='number'
            />
          </div>
          <div>
            <p className='title'>
              인게임 크기비율(Live2D가 매우 작아서 보통 8~14 사이 지정)
            </p>
            <InputStyled
              value={selectedData?.game_scale}
              onFocus={(e) => e.target.select()}
              onChange={(e) => {
                handleInputChange(e, 'game_scale');
              }}
              maxLength={30}
              type='number'
            />
          </div>
          <div>
            <p className='title'>
              로비 가로 위치 조정값 (0이 화면 중앙 기준, 음수는 왼쪽, 양수는
              오른쪽 이동)
            </p>
            <InputStyled
              value={selectedData?.lobby_offset_x}
              onFocus={(e) => e.target.select()}
              onChange={(e) => {
                handleInputChange(e, 'lobby_offset_x');
              }}
              maxLength={30}
              type='number'
            />
          </div>
          <div>
            <p className='title'>
              로비 세로 위치 조정값 (0이 화면 중앙 기준, 음수는 아래, 양수는
              위로 이동)
            </p>
            <InputStyled
              value={selectedData?.lobby_offset_y}
              onFocus={(e) => e.target.select()}
              onChange={(e) => {
                handleInputChange(e, 'lobby_offset_y');
              }}
              maxLength={30}
              type='number'
            />
          </div>
          <div>
            <p className='title'>로비 크기비율</p>
            <InputStyled
              value={selectedData?.lobby_game_scale}
              onFocus={(e) => e.target.select()}
              onChange={(e) => {
                handleInputChange(e, 'lobby_game_scale');
              }}
              maxLength={30}
              type='number'
            />
          </div>
          <div>
            <p className='title'>모델의 시선 방향</p>
            <Radio.Group
              onChange={(e) => {
                handleInputChange(e, 'direction');
              }}
              value={selectedData?.direction}
            >
              <Radio value='left'>왼쪽</Radio>
              <Radio value='center'>정면</Radio>
              <Radio value='right'>오른쪽</Radio>
            </Radio.Group>
          </div>
        </FormWrapper>
      </DefaultForm>
    </DefaultModal>
  );
};

export default ModelUpdateModal;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  p {
    color: ${theme.colors.dark_500};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.md};
  }
`;

const FormWrapper = styled.div`
  & > * + * {
    margin-top: 16px;
  }
  .title,
  .length-subtext {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .length-subtext {
    margin-top: 8px !important;
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200};
  }
  .ant-input-show-count-suffix {
    display: none;
  }
  .remove {
    display: flex;
    justify-content: end;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
